// @flow

import { useDispatch } from 'react-redux';

import { NOTIFICATION_ID as CART_NOTIFICATION_ID } from '@gandi/cart';
import { closeNotification, notifyDanger } from '@gandi/notifications';
import { useTranslator } from '@gandi/translate';

import { RegisterButton } from 'src/Domain/Fallback/RegisterButton';
import { ProvidedRowContainer } from 'src/Domain/ProvidedRowContainer';

import { addToCart, removeFromCart } from '../modules/actions';
import type { ResultItem } from '../types';

import { TransferDomainPrice } from './TransferDomainPrice';
import {
  getDomainPossibility,
  transferPossibility2AvailabilityIconName,
  useAvailabilityText,
} from './modules';

type Props = {
  domain: ResultItem,
};

export function DomainRow({ domain }: Props): React.MixedElement {
  const dispatch = useDispatch();
  const { __ } = useTranslator();
  const availabilityText = useAvailabilityText({ domain });

  const possibility = getDomainPossibility(domain);

  /**
   * Handle the addition of the suggestion in the cart.
   */
  const onClickItem: (evt: SyntheticMouseEvent<>) => any = (
    evt: SyntheticMouseEvent<>,
  ) => {
    evt.preventDefault();

    if (domain.addedToCart) {
      return dispatch(removeFromCart(domain)).catch(() => {
        dispatch(notifyDanger(__('An error occurred with your product.')));
      });
    }

    return dispatch(addToCart(domain)).catch(() => {
      // $FlowFixMe
      dispatch(closeNotification(CART_NOTIFICATION_ID));
      dispatch(notifyDanger(__('An error occurred with your product.')));
    });
  };
  const availabilityIconName =
    transferPossibility2AvailabilityIconName[possibility];

  return (
    <ProvidedRowContainer
      id={domain.fqdn}
      addedToCart={domain.addedToCart}
      availabilityIconName={availabilityIconName}
      corporate={domain.corporate}
      fqdn={domain.fqdn}
      onClickItem={onClickItem}
      availabilityText={availabilityText}
      loading={possibility === 'loading' || domain.isWorking}
      isCartActionnable={
        possibility === 'transferable' ||
        (possibility === 'creatable' && domain.addedToCart)
      }
      valid
    >
      {possibility === 'transferable' && (
        <TransferDomainPrice domain={domain} />
      )}
      {possibility === 'creatable' && !domain.addedToCart && (
        <RegisterButton fqdn={domain.fqdn} />
      )}
    </ProvidedRowContainer>
  );
}
